/**
 * Association Section Animation Logic
 */

document.addEventListener("DOMContentLoaded", () => {
	// Ensure GSAP is loaded
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. Association animation skipped.");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const sections = document.querySelectorAll('.osmerova-association-section[data-gsap="association-reveal"]');

	sections.forEach((section) => {
		let ctx = gsap.context(() => {
			
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: "top 85%",
					// markers: true
				}
			});

			// 1. Header Reveal
			const header = section.querySelector('.association-header');
			if (header) {
				// Use .to() because initial state is set in CSS
				tl.to(header, {
					autoAlpha: 1, // Handles opacity + visibility
					y: 0,
					duration: 0.8,
					ease: "power2.out"
				});
			}

			// 2. Logos Reveal
			// Target direct children of the grid to be safe
			const logos = section.querySelectorAll('.association-grid > *');
			if (logos.length > 0) {
				tl.to(logos, {
					autoAlpha: 1,
					y: 0,
					duration: 0.6,
					stagger: 0.1,
					ease: "power2.out"
				}, "-=0.4"); // Overlap slightly
			}

		}, section);
	});
});
